import { createReducer, on } from '@ngrx/store';
import { ReportSkinHealthGuidelineTakePictureActions } from './take-picture.actions';
import { ReportSkinHealthGuidelineTakePictureState } from './take-picture.interface';
import {
  initialReportSkinHealthGuidelineTakePictureState,
  reportSkinHealthGuidelineTakePictureState
} from './take-picture.state';

export const reportSkinHealthGuidelineTakePictureReducer = createReducer(
  reportSkinHealthGuidelineTakePictureState,
  on(
    ReportSkinHealthGuidelineTakePictureActions.reset,
    (): ReportSkinHealthGuidelineTakePictureState =>
      initialReportSkinHealthGuidelineTakePictureState()
  ),
  on(
    ReportSkinHealthGuidelineTakePictureActions.setLoading,
    (state, { loading }) => ({
      ...state,
      loading
    })
  ),
  on(
    ReportSkinHealthGuidelineTakePictureActions.setImage,
    (state, { image }) => ({
      ...state,
      image
    })
  ),
  on(
    ReportSkinHealthGuidelineTakePictureActions.setRetakePicture,
    (state, { retakePicture }) => ({
      ...state,
      retakePicture
    })
  ),
  on(
    ReportSkinHealthGuidelineTakePictureActions.uploadImageSubscriptionDataReceived,
    (state, { data }) => ({
      ...state,
      uploadImageResponse: data
    })
  )
);
